"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _Modal = _interopRequireDefault(require("@cimpress/react-components/lib/Modal"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _emotion = require("emotion");

var _UserIdentityModalFooter = _interopRequireDefault(require("./UserIdentityModalFooter"));

var _UserIdentityModalSelect = _interopRequireDefault(require("./UserIdentityModalSelect"));

var modalStyle = (0, _emotion.css)({
  '& > .modal-content > .modal-body': {
    overflowY: 'initial'
  }
});

var UserIdentityModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UserIdentityModal, _React$Component);

  function UserIdentityModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserIdentityModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserIdentityModal).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      identityId: null,
      identityType: null
    };
    return _this;
  }

  (0, _createClass2.default)(UserIdentityModal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Set the default selections to the currently selected ID and type.
      var _this$props = this.props,
          identityId = _this$props.identityId,
          identityType = _this$props.identityType;
      this.onChange(identityType, identityId);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      // If the modal is being redisplayed, reset the ID and type to the current ID and type.
      if (props.show && !this.props.show) {
        var identityId = props.identityId,
            identityType = props.identityType;
        this.onChange(identityType, identityId);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(identityType, identityId) {
      this.setState({
        identityType: identityType,
        identityId: identityId
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.props.onClose();
    }
  }, {
    key: "onSave",
    value: function onSave() {
      var _this$state = this.state,
          identityId = _this$state.identityId,
          identityType = _this$state.identityType;
      var _this$props2 = this.props,
          merchantOrder = _this$props2.merchantOrder,
          fulfillerOrder = _this$props2.fulfillerOrder,
          merchants = _this$props2.merchants;
      var combinedOrder = [].concat((0, _toConsumableArray2.default)(merchantOrder), (0, _toConsumableArray2.default)(fulfillerOrder));
      var hasOnlyOneIdentity = combinedOrder.length === 1;

      if (hasOnlyOneIdentity) {
        var id = combinedOrder[0];
        var type = merchants[id] ? 'merchants' : 'fulfillers';
        this.props.onSave(id, type);
      } else {
        this.props.onSave(identityId, identityType);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          fulfillers = _this$props3.fulfillers,
          merchants = _this$props3.merchants,
          fulfillerOrder = _this$props3.fulfillerOrder,
          merchantOrder = _this$props3.merchantOrder;
      var _this$state2 = this.state,
          identityId = _this$state2.identityId,
          identityType = _this$state2.identityType;
      var _this$props4 = this.props,
          currentId = _this$props4.identityId,
          currentType = _this$props4.identityType;
      var hasEitherFulfillerOrMerchant = Object.keys(fulfillers).length && fulfillerOrder && fulfillerOrder.length || Object.keys(merchants).length && merchantOrder && merchantOrder.length;
      var combinedOrder = [].concat((0, _toConsumableArray2.default)(merchantOrder), (0, _toConsumableArray2.default)(fulfillerOrder));
      var combinedLookup = (0, _objectSpread2.default)({}, merchants, fulfillers);
      var hasOnlyOneIdentity = combinedOrder.length === 1;
      var description = hasOnlyOneIdentity || !hasEitherFulfillerOrMerchant ? null : _react.default.createElement("p", {
        className: "identity-modal__description"
      }, "It seems like you have access to multiple businesses. Please choose which business you want to act on behalf of.");
      var canClose = currentId !== null && currentId !== undefined && currentType !== null && currentType !== undefined || !hasEitherFulfillerOrMerchant;
      var canSave = identityId !== null && identityId !== undefined && identityType !== null && identityType !== undefined || hasOnlyOneIdentity;

      var footer = _react.default.createElement(_UserIdentityModalFooter.default, {
        canClose: canClose,
        canSave: canSave,
        onClose: canClose ? this.onClose : null,
        onSave: canSave ? this.onSave : null
      });

      var selector = hasOnlyOneIdentity ? _react.default.createElement("p", null, "Your business is", ' ', _react.default.createElement("b", null, combinedLookup[combinedOrder[0]] ? combinedLookup[combinedOrder[0]].name : _react.default.createElement("i", null, "NAME NOT FOUND")), ". Click ", _react.default.createElement("b", null, "Save"), " to continue.") : _react.default.createElement(_UserIdentityModalSelect.default, {
        identityId: identityId,
        identityType: identityType,
        fulfillers: fulfillers,
        fulfillerOrder: fulfillerOrder,
        merchants: merchants,
        merchantOrder: merchantOrder,
        onChange: this.onChange
      });
      return _react.default.createElement(_Modal.default, {
        className: modalStyle,
        closeOnOutsideClick: canClose,
        footer: footer,
        show: this.props.show,
        title: "Choose who to view",
        onRequestHide: this.onClose
      }, description, hasEitherFulfillerOrMerchant ? selector : _react.default.createElement("h5", {
        style: {
          textAlign: 'center'
        }
      }, "You do not have any permission."));
    }
  }]);
  return UserIdentityModal;
}(_react.default.Component); // fulfillerOrder/merchantOrder is what actually gets used for all the logic
// fulfillers/merchants are what gets used as lookups for names.


var _default = UserIdentityModal;
exports.default = _default;